<template>
  <div class="waypoint">
    <div v-if="BPPoint">
      <div class="header">
        <div class="header-container" :style="{ backgroundImage: 'url(' + AbsImagePath + ')' }">
          <div class="ueberschrift">
            <div>{{ BPRoute[language].Titel }}</div>
            <h1>{{ BPPoint[language].station }}</h1>
          </div>

          <div class="stationnavigation">
            <router-link v-if="prevstation != null && prevstation.id" class="prev" :to="{ name: 'waypoint', params: { routeId: BPRoute.id, waypointId: prevstation.id }}">
              <img src="../assets/EKSElement-last-station.svg">
            </router-link>
            <router-link v-if="nextstation != null && nextstation.id" class="next" :to="{ name: 'waypoint', params: { routeId: BPRoute.id, waypointId: nextstation.id }}">
              <img src="../assets/EKSElement-next-station.svg">
            </router-link>
          </div>
        </div>
      </div>

      <div class="titel">
        <h1>{{ BPPoint[language].Titel }}</h1>
      </div>

      <div v-if="BPPoint.MainPic" class="image">
        <UploadedImage :image-path="BPPoint.MainPic" :fitwidth="true" :bildunterschrift="BPPoint[language].MainPicBildunterschrift" :bildnachweis="BPPoint[language].MainPicBildnachweis" />
      </div>

      <div v-if="BPPoint[language].Kurzbeschreibung" class="kurzbeschreibung" v-html="BPPoint[language].Kurzbeschreibung" />

      <div v-if="BPPoint[language].AudioFile" class="audio-container-outer">
        <Audio :title="BPPoint[language].AudioFileTitel" :audiofile="BPPoint[language].AudioFile" />
      </div>

      <div v-if="BPPoint[language].AudioFileText" class="audio-text-container">
        <div v-if="language == 'de'" class="audio-text-titel">Audiobeitrag lesen</div>
        <div v-if="language == 'pl'" class="audio-text-titel">przeczytaj audio artykuł</div>
        <div v-if="language == 'cz'" class="audio-text-titel">Audiobeitrag lesen</div>
        <div v-if="language == 'en'" class="audio-text-titel">read audio clip</div>


        <div v-if="!showaudiotext" class="text" v-html="BPPoint[language].AudioFileText.substring(0,250)" />
        <div v-if="showaudiotext" class="text" v-html="BPPoint[language].AudioFileText" />
        <a v-if="!showaudiotext && language == 'de'" @click="showaudiotext=1">[...] weiter lesen</a>
        <a v-if="!showaudiotext && language == 'pl'" @click="showaudiotext=1">[...] więcej</a>
        <a v-if="!showaudiotext && language == 'cz'" @click="showaudiotext=1">[...] weiter lesen</a>
        <a v-if="!showaudiotext && language == 'en'" @click="showaudiotext=1">[...] read more</a>
        <a v-if="showaudiotext && language == 'de'" @click="showaudiotext=0">weniger anzeigen</a>
        <a v-if="showaudiotext && language == 'pl'" @click="showaudiotext=0">weniger anzeigen</a>
        <a v-if="showaudiotext && language == 'cz'" @click="showaudiotext=0">weniger anzeigen</a>
        <a v-if="showaudiotext && language == 'en'" @click="showaudiotext=0">weniger anzeigen</a>
      </div>

      <div v-if="BPPoint[language].AudioFile2" class="audio-container-outer">
        <Audio :title="BPPoint[language].AudioFileTitel2" :audiofile="BPPoint[language].AudioFile2" />
      </div>

      <div v-if="BPPoint[language].AudioFileText2" class="audio-text-container">
        <div v-if="language == 'de'" class="audio-text-titel">Audiobeitrag lesen</div>
        <div v-if="language == 'pl'" class="audio-text-titel">przeczytaj audio artykuł</div>
        <div v-if="language == 'cz'" class="audio-text-titel">Audiobeitrag lesen</div>
        <div v-if="language == 'en'" class="audio-text-titel">read audio clip</div>

        <div v-if="!showaudiotext2" class="text" v-html="BPPoint[language].AudioFileText2.substring(0,250)" />
        <div v-if="showaudiotext2" class="text" v-html="BPPoint[language].AudioFileText2" />
        <a v-if="!showaudiotext2 && language == 'de'" @click="showaudiotext2=1">[...] weiter lesen</a>
        <a v-if="!showaudiotext2 && language == 'pl'" @click="showaudiotext2=1">[...] więcej</a>
        <a v-if="!showaudiotext2 && language == 'cz'" @click="showaudiotext2=1">[...] weiter lesen</a>
        <a v-if="!showaudiotext2 && language == 'en'" @click="showaudiotext2=1">[...] read more</a>
        <a v-if="showaudiotext2" @click="showaudiotext2=0">weniger anzeigen</a>
      </div>

      <div v-if="BPPoint[language].Inhalt" class="content-text-container">
        <div v-if="!showcontenttext" class="text withMaxHeight" v-html="BPPoint[language].Inhalt" />
        <div v-if="showcontenttext" class="text" v-html="BPPoint[language].Inhalt" />
        <a v-if="!showcontenttext && language == 'de'" @click="showcontenttext=1">[...] weiter lesen</a>
        <a v-if="!showcontenttext && language == 'pl'" @click="showcontenttext=1">[...] więcej</a>
        <a v-if="!showcontenttext && language == 'cz'" @click="showcontenttext=1">[...] weiter lesen</a>
        <a v-if="!showcontenttext && language == 'en'" @click="showcontenttext=1">[...] read more</a>
        <a v-if="showcontenttext" @click="showcontenttext=0">weniger anzeigen</a>
      </div>

      <Slider :pics="BPPoint.Bilder" />

      <template>
        <Akkordeon :list="additionalInformations" />
      </template>

      <Quiz v-if="BPPoint.Fragen" :questions="BPPoint.Fragen" :waypointid="BPPoint.id" />

      <div class="stationnavigation_bottom">
        <router-link v-if="prevstation != null && prevstation.id" class="prev" :to="{ name: 'waypoint', params: { routeId: BPRoute.id, waypointId: prevstation.id }}">
          <img src="../assets/EKSElement-last-station.svg">

          <div v-if="prevstation[language].station" class="nav_title">{{ prevstation[language].station }}</div>
        </router-link>
        <router-link v-if="nextstation != null && nextstation.id" class="next" :to="{ name: 'waypoint', params: { routeId: BPRoute.id, waypointId: nextstation.id }}">
          <div v-if="nextstation.de.station" class="nav_title">{{ nextstation[language].station }}</div>

          <img src="../assets/EKSElement-next-station.svg">
        </router-link>
      </div>

      <div class="backtooverview" :class="BPRoute.bereichsfarbe">
        <div class="inner">
          <table>
            <tr>
              <td>
                <img style="width: 20px" src="./../assets/EKSElement-back-overview.svg">
              </td>
              <td>
                <router-link to="/">zurück zur Übersicht</router-link>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">

import Audio from '../components/Audio'
import Slider from '../components/Slider'
import Akkordeon from '../components/Akkordeon'
import UploadedImage from '../components/UploadedImage'
import Quiz from '../components/Quiz'

export default {
  name: 'WaypointView',
  components: {Quiz, UploadedImage, Akkordeon, Slider, Audio},
  props: ['routeId','waypointId'],
  data: function () {
    return {
      showaudiotext: 0,
      showaudiotext2: 0,
      showcontenttext: 0,
    }
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
    BPPoint: function () {
      let self = this
      return this.$root.BPPoints.find((item) => item.id === self.waypointId)
    },
    additionalInformations: function () {
      return [
        {
          titel: this.BPPoint[this.language].Titel_addinfo1,
          content: this.BPPoint[this.language].Kurzbeschreibung_addinfo1,
        },
        {
          titel: this.BPPoint[this.language].Titel_addinfo2,
          content: this.BPPoint[this.language].Kurzbeschreibung_addinfo2,
        },
        {
          titel: this.BPPoint[this.language].Titel_addinfo3,
          content: this.BPPoint[this.language].Kurzbeschreibung_addinfo3,
        },
        {
          titel: this.BPPoint[this.language].Titel_addinfo4,
          content: this.BPPoint[this.language].Kurzbeschreibung_addinfo4,
        },
      ]
    },
    BPRoute: function () {
      let self = this
      return this.$root.BPRoutes.find((item) => item.id === self.routeId)
    },
    BPfilteredWaypoints() {
      // ALLE: return this.$root.BPPoints
      let bproute = this.BPRoute
      let BPPoints = this.$root.BPPoints
      let self = this
      //console.log(bproute.Punkte)
      let list = []

      bproute.Punkte.map(function (value, key) {
        let ret = BPPoints.filter((item) => item.id == value)
        //console.log(ret);
        if (!ret[0]) {
          //console.log(ret)
          return
        }

        list.push(ret[0])
        //console.log(value);
      })

      return list

    },
    AbsImagePath: function () {

      //console.log(process.env.apiPath);
      //console.log(process.env.BASE_URL);
      if (this.BPRoute.MainPic && this.BPRoute.MainPic.length)
        if (window.innerWidth > 800)
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/1600x800/' + this.BPRoute.MainPic
        else
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/800x400/' + this.BPRoute.MainPic
      else {
        if (window.innerWidth > 800)
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/1600x800/startseite/titelbild.jpg'
        else
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/800x400/startseite/titelbild.jpg'
      }
    },
    prevstation: function () {
      let index = this.BPfilteredWaypoints.indexOf(this.BPPoint)
      console.log('PREVINDEX: ', index)
      if(index > 0 && index <= this.BPfilteredWaypoints.length - 1)
        return this.BPfilteredWaypoints[index - 1]
      else return null
    },
    nextstation: function () {
      let index = this.BPfilteredWaypoints.indexOf(this.BPPoint)
      console.log('NEXTINDEX: ', index)
      if(index >= 0 && index < this.BPfilteredWaypoints.length - 1)
        return this.BPfilteredWaypoints[index + 1]
      else return null
    },
  },
}
</script>

<style lang="scss" scoped>
.header-container {
  padding-bottom: 40%;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;

  @media screen and (max-width: 768px) {
    padding-bottom: 47%;
  }
  @media screen and (max-width: 480px) {
    padding-bottom: 65%;

    background-size: 140%;
  }

  .ueberschrift {
    position: absolute;
    top: 30px;
    bottom: 30px;
    left: 80px;
    right: 80px;
    text-align: center;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #d3c6ac;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    @media screen and (max-width: 768px) {
      left: 50px;
      right: 50px;
    }
    @media screen and (max-width: 480px) {
      left: 30px;
      right: 30px;
      padding: 15px;
    }

    div {
      font-weight: 700;
      text-transform: uppercase;
      color: white;
      font-size: 20px;
      line-height: 1.1;
      width: 100px;
      text-align: left;
      margin-bottom: 20px;

      width: 80%;
      font-size: 6vw;

      @media screen and (max-width: 768px) {
        width: 80%;
        font-size: 5vw;
      }
      @media screen and (max-width: 480px) {
        width: 200px;
        font-size: 7vw;
      }
    }

    h1 {
      text-align: left;
      display: block;
      margin-bottom: 0;
      padding-bottom: 0;
      border: 0;
      font-size: 32px;
      line-height: 1.1;
      font-weight: 700;
      text-transform: uppercase;
      color: white;

      position: absolute;
      bottom: 10px;

      font-size: 10vw;

      @media screen and (max-width: 768px) {
        font-size: 11vw;
      }
      @media screen and (max-width: 480px) {
        font-size: 14vw;
        line-height: 1.0;
      }
    }
  }
}


.waypoint {
  background-color: #d3c6ac;

  .titel {
    max-width: 1024px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 40px;
    padding: 0px 80px;
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
      padding: 0px 30px;
    }
    @media screen and (max-width: 480px) {
      padding: 0px 30px;
    }

    h1 {
      font-weight: 300;
      font-size: 36px;
      line-height: 1.1;
      color: #350f37;
    }
  }

  .image {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0px 80px;
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }

  .kurzbeschreibung {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0px 80px;
    box-sizing: border-box;

    margin-top: 40px;
    margin-bottom: 40px;
    font-weight: 600;
    font-size: 14px;

    @media screen and (max-width: 768px) {
      padding: 0px 30px;
    }
    @media screen and (max-width: 480px) {
      padding: 0px 30px;
    }
  }

  .audio-container-outer {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0px 80px;
    box-sizing: border-box;
    margin-top: 40px;
    margin-bottom: 0px;

    @media screen and (max-width: 768px) {
      padding: 0px 30px;
    }
    @media screen and (max-width: 480px) {
      padding: 0px 30px;
    }
  }

  .audio-text-container {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0px 80px;
    box-sizing: border-box;
    margin-top: 40px;
    margin-bottom: 40px;

    @media screen and (max-width: 768px) {
      padding: 0px 30px;
    }
    @media screen and (max-width: 480px) {
      padding: 0px 30px;
    }

    .audio-text-titel {
      font-weight: 700;
      margin-bottom: 5px;
    }

    .text {
      font-style: italic !important;
      font-weight: 400;
      ::v-deep p {
        font-weight: 400;
        font-style: italic !important;
      }
    }
  }

  .content-text-container {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0px 80px;
    box-sizing: border-box;
    margin-bottom: 40px;

    @media screen and (max-width: 768px) {
      padding: 0px 30px;
    }
    @media screen and (max-width: 480px) {
      padding: 0px 30px;
    }

    .text {
      font-style: italic !important;

      ::v-deep h2 {
        font-weight: 700;
        font-style: normal;
      }

      ::v-deep p {
        font-style: normal;
      }

      &.withMaxHeight {
        max-height: 60px;
        overflow: hidden;
      }
    }
  }

  .backtooverview {
    padding: 20px;
    box-sizing: border-box;
    margin-top: 40px;

    &.bg-orangebraun {
      background-color: #8c4a29;
    }

    &.bg-senfgelb {
      background-color: #b78f2f;
    }

    &.bg-rotbraun {
      background-color: #531918;
    }

    ::v-deep div {
      border: 1px solid #c1b08c;
      padding: 20px 10px;
      box-sizing: border-box;
      width: 240px;
      display: inline-block;

      img {
        margin-right: 20px;
      }
      a {
        text-transform: uppercase;
        font-size: 20px;
        line-height: 1.1;
        color: white;
      }
    }
  }

  .stationnavigation {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;

    a.prev {
      position: absolute;
      left: 25px;

      @media screen and (max-width: 768px) {
        left: 15px;
      }
      @media screen and (max-width: 480px) {
        left: 5px;
      }
    }
    a.next {
      position: absolute;
      right: 25px;

      @media screen and (max-width: 768px) {
        right: 15px;
      }
      @media screen and (max-width: 480px) {
        right: 5px;
      }
    }
    img {
      width: 20px;
    }
  }

  .stationnavigation_bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
      padding: 0 20px;
    }
    @media screen and (max-width: 480px) {

    }

    a.prev {
      display: flex;
      flex-direction: row;
      justify-content: center;

      @media screen and (max-width: 768px) {

      }
      @media screen and (max-width: 480px) {

      }

      .nav_title {
        margin-left: 40px;

        @media screen and (max-width: 768px) {
          margin-left: 20px;
        }
        @media screen and (max-width: 480px) {
          margin-left: 10px;
        }
      }
    }
    a.next {
      display: flex;
      flex-direction: row;
      justify-content: center;

      @media screen and (max-width: 768px) {

      }
      @media screen and (max-width: 480px) {

      }

      .nav_title {
        margin-right: 40px;

        @media screen and (max-width: 768px) {
          margin-right: 20px;
        }
        @media screen and (max-width: 480px) {
          margin-right: 10px;
        }
      }
    }

    .nav_title {
      border: 1px solid #c1b08c;
      box-sizing: border-box;
      padding: 20px 40px;

      color: white;
      text-transform: uppercase;
      font-size: 30px;

      @media screen and (max-width: 768px) {
        font-size: 20px;
        padding: 20px 30px;
      }
      @media screen and (max-width: 480px) {
        font-size: 16px;
        padding: 10px 15px;
      }
    }

    img {
      width: 20px;
    }
  }
}
</style>
